<div class="form-field radio-wrapper" [formGroup]="group" [ngStyle]="field.containerStyles">
  <label *ngIf="field.label" class="radio-label-padding" [ngStyle]="field.labelStyles" [innerHTML]="field.label | gioNoSanitize"></label>
  <mat-radio-group [formControlName]="field.name" [required]="field.required" [ngStyle]="field.radioGroupStyles" [color]="field.color">
    <mat-radio-button [gioEnableControl]="isEnabledFn(field.name, field.id)" *ngFor="let item of field.options"
      [ngStyle]="field.radioButtonStyles" [value]="item.id" color="primary">{{item.value}}</mat-radio-button>
  </mat-radio-group>
</div>
